import { useEffect } from 'react';
import Fade from '@mui/material/Fade';
import NotificationDialog from '../../components/dialog/NotificationDialog';
import SelectableLoader from '../../components/loaders/SelectableLoader';
import TransparentBlocker from '../../components/blocker/GrayTransparentBlocker';
import VizzleSnackbar from '../../components/snackbar/VizzleSnackbar';
import { useDomain } from '../../states/AppDomainProvider';
import { useHandleSessionExpired } from '../hooks/HandleSessionExpiredHook';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import { MAIN_CONTENT_ID } from '../../constants/Accessibility';
import SkipToMainContent from '../../components/accessibility/SkipToMainContent';

/**
 * Main container of the application.
 * Wrap the component of the application to ensure the consistency
 * of the common behaviour e.g. fading in, displaying sesstion timeout and etc.
 *
 * @param {*} props of
 * children - components to add inside the main container.
 * prop of the Fade component
 */
const defaultProps = {
  children: null,
  showSkipToMainContent: true,
};

export default function VizzleMainContainer(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { children, showSkipToMainContent, ...rest } = mergedProps;
  const { uiDomain } = useDomain();

  const {
    spinningLoader,
    snackbar,
    blockScreen,
  } = uiDomain.domainData;

  const onSnackbarClose = () => {
    uiDomain.closeSnackbar();
  };

  const {
    notificationDialog,
    onNotificationDialogClose,
  } = useHandleSessionExpired();

  useEffect(() => {
    uiDomain.blockScreen(false);
    // eslint-disable-next-line
  }, []);

  return (
    // default timeout is 1 second
    <>
      {showSkipToMainContent && <SkipToMainContent targetId={MAIN_CONTENT_ID} />}
      <div {...rest} id={MAIN_CONTENT_ID}>
        <Fade timeout={1000} in>
          {children}
        </Fade>
        <SelectableLoader {...spinningLoader} />
        <VizzleSnackbar {...snackbar} onClose={onSnackbarClose} />
        <NotificationDialog {...notificationDialog} onClose={onNotificationDialogClose} />
        <TransparentBlocker show={blockScreen} />
      </div>
    </>
  );
}
